/* eslint-disable import/no-absolute-path */
/* eslint-disable import/no-unresolved */
import jsSVG from 'assets/resources/pages/software-services/logo/js.svg';
import vueSVG from 'assets/resources/pages/software-services/logo/vue.svg';
import reactSVG from 'assets/resources/pages/software-services/logo/react.svg';
import angularSVG from 'assets/resources/pages/software-services/logo/angular.svg';

export default [
  {
    src: jsSVG,
    nameClass: 'img-fluid',
    alt: 'JavaScript'
  },
  {
    src: vueSVG,
    nameClass: 'img-fluid',
    alt: 'VueJS'
  },
  {
    src: reactSVG,
    nameClass: 'img-fluid',
    alt: 'ReactJS'
  },
  {
    src: angularSVG,
    nameClass: 'img-fluid',
    alt: 'Angular'
  },
]